// extracted by mini-css-extract-plugin
export default {"thumb":"grid-shape-item-module__thumb--F8UjY"};